import { useSearchParams } from "react-router";

const PARAM = "project";

// Same reasoning as snippets' `useSelectedProjectIds`: the URL is the source of truth, not React
// state, so the selection survives a refresh and is shareable/bookmarkable. Singular here
// because, unlike the snippets catalog (cross-project by design), a SEO deploy is always scoped
// to one project's own environments (see obsidian/Product/SEO Sync.md) — there's nothing to view
// without picking exactly one.
export function useSelectedProjectId(): [string | null, (projectId: string | null) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedProjectId = searchParams.get(PARAM);

  const setSelectedProjectId = (projectId: string | null) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (projectId) {
          next.set(PARAM, projectId);
        } else {
          next.delete(PARAM);
        }
        return next;
      },
      { replace: true }
    );
  };

  return [selectedProjectId, setSelectedProjectId];
}
